import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios'; 
import SalesDonutChart from '../../components/salesPerformance/SalesDonutChart';
import SalesBarChart from '../../components/salesPerformance/SalesBarChart';
import SalesDetailBarChart from '../../components/salesPerformance/SalesDetailBarChart';
import SalesDetailListTable from '../../components/salesPerformance/SalesDetailListTable';
import SalesFilterSelectBox from '../../components/salesPerformance/SalesFilterSelectBox';

// 레거시 연동용 하위 껍데기 스펙 유지
const KPISummaryCards = (props) => <div style={{ padding: '15px', background: '#fff', border: '1px solid #ddd', borderRadius: '8px' }}>KPI Summary Card Component</div>;
const ProjectListTable = (props) => <div style={{ padding: '15px', background: '#fff', border: '1px solid #ddd', borderRadius: '8px', height: '100%' }}>Project List Table Component</div>;
const MaintenanceContractTable = (props) => <div style={{ padding: '15px', background: '#fff', border: '1px solid #ddd', borderRadius: '8px', height: '100%' }}>Maintenance Contract Table Component</div>;
const SalesActivityTimeline = (props) => <div style={{ padding: '15px', background: '#fff', border: '1px solid #ddd', borderRadius: '8px' }}>Sales Activity Timeline Component (Sticky)</div>;
const ClientSearchModal = (props) => null;

const SalesPerformanceContainer = () => {
    const [searchYear, setSearchYear] = useState(new Date().getFullYear());
    const [isLoading, setIsLoading] = useState(false); 
    
    // 부서 및 개인 필터링 상태값 정의
    const [activeFilter, setActiveFilter] = useState({ dept: 'ALL', member: 'ALL' });

    // 레거시 상태 변수 보존 컨텍스트
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedClient, setSelectedClient] = useState({ partnerNm: '고객사명' });
    const [clientRankingInfo, setClientRankingInfo] = useState({ salesRank: 1, profitRank: 1 });
    const [viewMode, setViewMode] = useState('all');
    const [projectDetailList, setProjectDetailList] = useState([]);
    const [forecastProjectDetailList, setForecastProjectDetailList] = useState([]);
    const [maintenanceDetailList, setMaintenanceDetailList] = useState([]);
    const [forecastMaintenanceDetailList, setForecastMaintenanceDetailList] = useState([]);
    const [clientActionListState, setClientActionListState] = useState([]);
    const [performanceList, setPerformanceList] = useState([]);
    const [kpiCardsState, setKpiCardsState] = useState({ yearly: {}, trendData: [] });

    const [salesData, setSalesData] = useState({
        targetSales: 2000000000,       
        achievedSales: 1350000000,     
        targetProfit: 725000000,       
        achievedProfit: 280000000,     
        actual: { 
            project: 700010000, 
            maintenance: 30000000 
        },
        forecast: { 
            project: 40002000, 
            maintenance: 200000000 
        },
        actualProfit: { 
            project: 200000, 
            maintenance: 10000000 
        },
        forecastProfit: { 
            project: 1500000, 
            maintenance: 70000000 
        }
    });

    const fetchSalesPerformance = useCallback(async (year, filter) => {
        setIsLoading(true);
        try {
            const response = await axios.get(`/api/sales/performance?year=${year}&dept=${filter.dept}&member=${filter.member}`);
            if (response.data) {
                setSalesData(response.data);
            }
        } catch (error) {
            console.error(`${year}년도 실적 조회 실패:`, error);
        } finally {
            setIsLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchSalesPerformance(searchYear, activeFilter);
    }, [searchYear, activeFilter, fetchSalesPerformance]);

    const handleFilterChange = (filterData) => {
        setActiveFilter(filterData);
        console.log("대시보드 필터 변경 감지:", filterData);
    };

    return (
        <div style={{ padding: '10px 24px 24px 0px', backgroundColor: '#ffffff', width: '100%', boxSizing: 'border-box', fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif' }}>
            
            {/* 최상단 영역: 부서 / 개인 필터 선택박스 컴포넌트 마운트 */}
            <SalesFilterSelectBox onFilterChange={handleFilterChange} />

            {/* 메인 대시보드 그래픽 트랙 */}
            <div style={{ 
                width: '100%', 
                display: 'flex', 
                flexDirection: 'row', 
                gap: '10px', 
                background: '#ffffff', 
                boxSizing: 'border-box',
                position: 'relative' 
            }}>
                
                {isLoading && (
                    <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(255, 255, 255, 0.7)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 10, fontSize: '15px', fontWeight: '700', color: '#1E3A8A' }}>
                        데이터를 동기화 중입니다...
                    </div>
                )}
                
                {/* [좌측 구역] 차트 컴포넌트 간의 수직 간격(gap) 10px 스펙 */}
                <div style={{ flex: '1.5 1 0%', display: 'flex', flexDirection: 'column', gap: '10px' }}>
                    
                    {/* 1층: 두 개의 도넛 차트 세트 */}
                    <div style={{ display: 'flex', flexDirection: 'row', width: '100%', height: '180px', gap: '10px' }}>
                        <div style={{ flex: '1', marginLeft: '0px' }}>
                            {/* 💡 year 속성 주입 */}
                            <SalesDonutChart 
                                title="년 매출 목표"
                                year={searchYear}
                                targetAmount={salesData.targetSales}
                                achievedAmount={salesData.achievedSales}
                                activeColor="#1E3A8A" 
                                headerBg="#EBF7F2"
                                headerTextColor="#144D37"
                            />
                        </div>
                        <div style={{ flex: '1' }}>
                            {/* 💡 year 속성 주입 */}
                            <SalesDonutChart 
                                title="년 매출이익 목표"
                                year={searchYear}
                                targetAmount={salesData.targetProfit}
                                achievedAmount={salesData.achievedProfit}
                                activeColor="#6D28D9" 
                                headerBg="#F3EFFF"
                                headerTextColor="#4C1D95"
                            />
                        </div>
                    </div>

                    {/* 2층: 목표 대비 실적 추이 분석 막대 차트 */}
                    <div style={{ width: '100%', height: '260px', paddingLeft: '0px', boxSizing: 'border-box' }}>
                        {/* 💡 year 속성 주입 */}
                        <SalesBarChart 
                            salesData={salesData} 
                            year={searchYear}
                        />
                    </div>

                    {/* 3층: 상세 분석 막대 차트 */}
                    <div style={{ width: '100%', height: '260px', paddingLeft: '0px', boxSizing: 'border-box' }}>
                        {/* 💡 year 속성 주입 */}
                        <SalesDetailBarChart 
                            salesData={salesData} 
                            year={searchYear}
                        />
                    </div>
                </div>

                <div style={{ display: 'none' }} />

                {/* [우측 구역] 가로 비중 1.5 확장 및 대칭 정렬 상태 보존 */}
                <div style={{ 
                    flex: '1.5 1 0%', 
                    marginRight: '0px', 
                    marginLeft: '0px',
                    boxSizing: 'border-box',
                    paddingLeft: '0px', 
                    height: '720px' 
                }}>
                    {/* 💡 테이블 제목도 가변 연도로 표현하기 위해 year 주입 */}
                    <SalesDetailListTable 
                        title={`${searchYear}년 사업 유형별 상세 프로젝트 리스트`} 
                    />
                </div>

            </div>
        </div>
    );
};

export default SalesPerformanceContainer;
